export interface BusinessCategory {
	Id: number;
	Name: string;
	Description: string;
	Enabled: boolean;
	DateCreated;
	GroupId: number;
	CategoryGroup;
}

export class CreateBusinessCategory {
	public Name;
	public Description;
	public Group;
	public GroupId: number;
	public CategoryGroup: string;
}

export class EditBusinessCategory extends CreateBusinessCategory {
	public Id: number;
	public Enabled: boolean;
	constructor(item?: BusinessCategory) {
        super();
		this.Id = item && item.Id;
		this.Name = item && item.Name;
		this.Description = item && item.Description;
		this.GroupId = item && item.GroupId;
		this.CategoryGroup = item && item.CategoryGroup;
	}
}





// WEBPACK FOOTER //
// ./src/app/models/inModels/business-category.ts